/**
 * Shared IndexedDB opener for the offline queues.
 *
 * Version 1 was service logs only. Version 2 adds the punch queue and
 * the tablet name cache. Opening version 1 after this would fail, so
 * both queues use this opener.
 */
export const DB_NAME = 'k12erp-offline';
export const DB_VERSION = 2;
export const SERVICE_LOG_STORE = 'service_logs';
export const PUNCH_STORE = 'punches';
export const ROSTER_STORE = 'punch_roster';

export function openOfflineDb() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(SERVICE_LOG_STORE)) {
        const logs = db.createObjectStore(SERVICE_LOG_STORE, { keyPath: 'client_uuid' });
        logs.createIndex('status', 'status', { unique: false });
        logs.createIndex('created_at', 'created_at', { unique: false });
      }
      if (!db.objectStoreNames.contains(PUNCH_STORE)) {
        const punches = db.createObjectStore(PUNCH_STORE, { keyPath: 'client_uuid' });
        punches.createIndex('status', 'status', { unique: false });
        punches.createIndex('tapped_at', 'tapped_at', { unique: false });
      }
      if (!db.objectStoreNames.contains(ROSTER_STORE)) {
        db.createObjectStore(ROSTER_STORE, { keyPath: 'badge_number' });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}
